module.exports = __webpack_public_path__ + "img/avksentieva.d01eafdc.jpg";